"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRoutes = void 0;

var _react = _interopRequireWildcard(require("react"));

var _RoutePathResolver = require("../../builder/RoutePathResolver");

var _RouteContext = require("../contexts/RouteContext");

var _LocationNotFoundError = require("../errors/LocationNotFoundError");

var _useLocation = require("./useLocation");

/**
 * Receives a route builder and returns a corresponding rendered route.
 */
const useRoutes = builder => {
  var _parentRoute$nextLoca;

  const parentRoute = (0, _react.useContext)(_RouteContext.RouteContext);
  const location = (0, _useLocation.useLocation)();
  const locationToResolve = (_parentRoute$nextLoca = parentRoute === null || parentRoute === void 0 ? void 0 : parentRoute.nextLocation) !== null && _parentRoute$nextLoca !== void 0 ? _parentRoute$nextLoca : location;
  const resolver = (0, _react.useMemo)(() => _RoutePathResolver.RoutePathResolver.getFromBuilder(builder), [builder]);
  const {
    routeContextValue,
    result
  } = (0, _react.useMemo)(() => {
    const resolved = resolver.resolve(locationToResolve)[0];

    if (resolved === undefined) {
      throw new _LocationNotFoundError.LocationNotFoundError("Current location could not be resolved.");
    }

    const ancestorRoutes = parentRoute ? parentRoute.ancestorRoutes.concat() : [];
    ancestorRoutes.push({
      link: builder.getBuilderLink().getAttachmentRoot(),
      location: (parentRoute === null || parentRoute === void 0 ? void 0 : parentRoute.routeLocation) || {
        pathname: "/",
        state: null
      }
    }); // const result = resolved.route.action(resolved.match as never);

    const result = /*#__PURE__*/_react.default.createElement(resolved.route.action, resolved.match);

    const routeContextValue = {
      route: resolved.route,
      ancestorRoutes,
      routeLocation: resolved.currentLocation,
      nextLocation: resolved.remainingLocation
    };
    return {
      result,
      routeContextValue
    };
  }, [parentRoute, resolver, locationToResolve]);
  return /*#__PURE__*/_react.default.createElement(_RouteContext.RouteContext.Provider, {
    value: routeContextValue
  }, result);
};

exports.useRoutes = useRoutes;